// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/analytics/Recommendations.scss
// module id = 1288
// module chunks = 0